import { render, staticRenderFns } from "./package-freight-options.vue?vue&type=template&id=526e7a6c"
import script from "./package-freight-options.vue?vue&type=script&setup=true&lang=js"
export * from "./package-freight-options.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports